<ng-template #template>
  <div
    [class]="model.getRootCss()"
    (click)="model.doAction()"
    [key2click]
    role="tab"
    [attr.id]="'tab-' + model.id"
    [attr.aria-selected]="model.active"
    [attr.aria-controls]="'scrollableDiv-' + model.id"
  >
    <span *ngIf="model.hasTitle" [class]="model.getTitleCss()">
      {{ model.title }}
    </span>
    <svg
      *ngIf="model.hasIcon"
      [iconName]="model.iconName"
      [size]="'auto'"
      [class]="model.getIconCss()"
      [title]="model.tooltip || model.title"
      sv-ng-svg-icon
    ></svg>
  </div>
</ng-template>
